import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const DELETE_WHD_STMT_ROW_REQUEST = 'DELETE_WHD_STMT_ROW_REQUEST';
export const DELETE_WHD_STMT_ROW_SUCCESS = 'DELETE_WHD_STMT_ROW_SUCCESS';
export const DELETE_WHD_STMT_ROW_FAILURE = 'DELETE_WHD_STMT_ROW_FAILURE';

function requestDeleteStatementRow() {
  return {
    type: DELETE_WHD_STMT_ROW_REQUEST,
  };
}

function receiveDeleteStatementRow(structure, statement, isStructureValid, validationResult, topAccount) {
  return {
    type: DELETE_WHD_STMT_ROW_SUCCESS,
    isStructureValid,
    structure,
    statement,
    validationResult,
    topAccount
  };
}

function rejectDeleteStatementRow() {
  return {
    type: DELETE_WHD_STMT_ROW_FAILURE,
  };
}

export function deleteStatementRow(accountId, rowToDelete) {
  return (dispatch) => {
    dispatch(requestDeleteStatementRow());
    const promise = () => ApiService
      .deleteStatementRow(accountId, rowToDelete)
      .then((response) => {
        if (response.data && response.data.structure && response.data.statement) {
          toastr.success('Save Successful', 'Deletion of row was successful');
          dispatch(receiveDeleteStatementRow(response.data.structure, response.data.statement, response.data.isStructureValid, response.data.validationResult, response.topAccount));
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when trying to save the changes');
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectDeleteStatementRow()), true)));

    return promise();
  };
}
